import MonthlyRecord from '@/components/monthly_record/MonthlyRecord.vue';

export default {
  name: 'DashboardMonthlyRecord',
  components: { MonthlyRecord },
  data: () => ({})
};
